export const CLIENT_CONSENT_PROMPT_TOASTS_FOR_CLIENTS_STORAGE_KEY =
  'CLIENT_CONSENT_PROMPT_TOASTS_FOR_CLIENTS_STORAGE_KEY_48232994-6DB8-4E4A-9E0C-B36B76C31DEC';
export const CLIENT_CONSENT_PROMPT_TOAST_DURATION = 2 * 60 * 1000;
export const MAX_CONSENT_PROMPT_TOASTS_PER_CLIENT = 2;
export const PROVIDER_CONSENT_MODAL_DISMISSED_DATE_KEY =
  'PROVIDER_CONSENT_MODAL_DISMISSED_DATE_B4AC01E4-1E14-4163-96FF-4F4B963736CD';
export const MINOR_ACKNOWLEDGEMENT_TEXT =
  'It looks like this client is a minor. Please confirm that a parent or guardian is present before enabling transcription.';
export const MINOR_ACKNOWLEDGEMENT_CONFIRM_BUTTON_TEXT = 'Start transcription';
export const MINOR_ACKNOWLEDGEMENT_CANCEL_BUTTON_TEXT = 'Cancel';
